import {api} from './api';

/**
 * 用户Token统计接口
 */
export interface UserTokenStats {
    id: number;
    userId: string;
    modelName: string;
    statsDate: string;
    totalPromptTokens: number;
    totalCompletionTokens: number;
    totalTokens: number;
    totalCost: number;
    callCount: number;
}

/**
 * Token统计摘要
 */
export interface TokenStatsSummary {
    totalUsers: number;
    totalTokens: number;
    totalPromptTokens: number;
    totalCompletionTokens: number;
    totalCost: number;
    totalCallCount: number;
    todayTokens: number;
    todayCost: number;
    modelBreakdown: {
        [modelName: string]: {
            totalTokens: number;
            totalCost: number;
            callCount: number;
        };
    };
}

/**
 * 分页响应
 */
export interface TokenStatsPageResponse {
    list: UserTokenStats[];
    total: number;
    page: number;
    size: number;
    totalPages: number;
}

const API_BASE_URL = '/api/v1/token-stats';

class TokenStatsService {
    /**
     * 获取Token统计摘要
     */
    async getSummary(startDate?: string, endDate?: string, modelName?: string): Promise<TokenStatsSummary> {
        try {
            const params: Record<string, string> = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;
            if (modelName) params.modelName = modelName;

            const response = await api.get(`${API_BASE_URL}/summary`, {params});
            return response.data.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * 获取所有用户的Token统计（分页）
     */
    async getAllUserStats(page: number = 0, size: number = 10, startDate?: string, endDate?: string, modelName?: string): Promise<TokenStatsPageResponse> {
        try {
            const params: Record<string, string | number> = {page, size};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;
            if (modelName) params.modelName = modelName;

            const response = await api.get(`${API_BASE_URL}/users`, {params});
            return response.data.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * 获取指定用户的Token统计
     */
    async getUserTokenStats(userId: string, startDate?: string, endDate?: string, modelName?: string): Promise<UserTokenStats[]> {
        try {
            const params: Record<string, string> = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;
            if (modelName) params.modelName = modelName;

            const response = await api.get(`${API_BASE_URL}/user/${userId}`, {params});
            return response.data.data;
        } catch (error) {
            throw error;
        }
    }
}

export const tokenStatsService = new TokenStatsService();
